export const ROUTES = {
  SITE_SELECT: '/select-site',
  LOGIN:       '/login',
  DASHBOARD:   '/',
  TICKETS:     '/tickets',
  SUBMIT:      '/tickets/submit',
  TICKET_DETAIL: '/tickets/:id',
  PROFILE:     '/profile',
  NOTIFICATIONS: '/notifications',
}
